import { render, staticRenderFns } from "./robot1.vue?vue&type=template&id=f0ff7740&scoped=true&"
import script from "./robot1.vue?vue&type=script&lang=js&"
export * from "./robot1.vue?vue&type=script&lang=js&"
import style0 from "./robot1.vue?vue&type=style&index=0&id=f0ff7740&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ff7740",
  null
  
)

export default component.exports